import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CredibilityStrip } from './components/CredibilityStrip';
import { Services } from './components/Services';
import { Assessment } from './components/Assessment';
import { Audience } from './components/Audience';
import { Proof } from './components/Proof';
import { BuildProof } from './components/BuildProof';
import { CtaBand } from './components/CtaBand';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans antialiased" data-id="element-0" data-mp="2mn5a0exnchfn">
      <Header data-id="element-1" data-mp="31aysc7e49y1x" />
      <main data-id="element-2" data-mp="31brzh9gzmpkl">
        <Hero data-id="element-3" data-mp="31c9vq63nh3si" />
        <CredibilityStrip data-id="element-4" data-mp="31ctefp14jw7l" />
        <Services data-id="element-5" data-mp="2wk06yte9u9rt" />
        <Assessment data-id="element-6" data-mp="2wjqi594yq8np" />
        <Audience data-id="element-7" data-mp="2wj8dbo48im46" />
        <Proof data-id="element-8" data-mp="2wip7v6vrtq71" />
        <BuildProof data-id="element-9" data-mp="2wi5nzkmk8rqd" />
        <CtaBand data-id="element-10" data-mp="28u5zysgmvffh" />
      </main>
      <Footer data-id="element-11" data-mp="28te37ebavbnm" />
    </div>;
}